import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// css
import * as styles from "./EmployeeWellbeing.module.css";

// Import icons
import empIcon1 from "../../../images/icons/emp-icn1.png";
import empIcon2 from "../../../images/icons/emp-icn2.png";
import empIcon3 from "../../../images/icons/emp-icn3.png";
import empIcon4 from "../../../images/icons/emp-icn4.png";
import empIcon5 from "../../../images/icons/emp-icn5.png";
import empIcon6 from "../../../images/icons/emp-icn6.png";

const EmployeeWellbeingComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const topStats = [
    {
      icon: empIcon1,
      text: "80% of employees today show early signs of lifestyle and metabolic stress caused by long work hours and poor routines.",
    },
    {
      icon: empIcon2,
      text: "Sedentary lifestyles and stress create chronic conditions early, often in employees under 40.",
    },
    {
      icon: empIcon3,
      text: "Annual health check-ups detect problems late. Moreover, they don't prevent employee health or prevent lifestyle diseases.",
    },
  ];

  const bottomStats = [
    {
      icon: empIcon4,
      title: "Lost productivity",
    },
    {
      icon: empIcon5,
      title: "Higher medical claims",
    },
    {
      icon: empIcon6,
      title: "Lower morale and retention",
    },
  ];

  return (
    <section className={styles.employeeWellbeingWrapper}>
      <div
        className={`container scroll_animate ${inView && "inview"}`}
        ref={ref}
      >
        {/* Header Section */}
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h2 className={styles.mainTitle}>
                The Hidden Cost of Poor Employee Wellbeing
              </h2>
              <p className={styles.mainDescription}>
                Across India, employee wellbeing has reached a tipping point,
                rising stress, long hours, and lifestyle habits are affecting
                workforce health.
              </p>
            </div>
          </div>
        </div>

        {/* India Map and Stats Section */}
        <div className="row">
          <div className="col-lg-6 col-12">
            <div className={styles.mapContainer}>
              <StaticImage
                src="../../../images/forEmployee/india-img.png"
                alt="India Map"
                placeholder="blurred"
                quality={90}
                className={styles.indiaMap}
                loading="lazy"
              />
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className={styles.statsContainer}>
              {topStats.map((stat, index) => (
                <div key={index} className={styles.statCard}>
                  <div className={styles.statIcon}>
                    <img
                      src={stat.icon}
                      alt={`Stat ${index + 1}`}
                      className={styles.iconImage}
                    />
                  </div>
                  <p className={styles.statText}>{stat.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="row">
          <div className="col-12">
            <div className={styles.bottomSection}>
              <h3 className={styles.bottomTitle}>
                Poor employee wellbeing can directly affects performance,
                morale, and business outcomes.
              </h3>
              <div className={styles.bottomStatsGrid}>
                {bottomStats.map((stat, index) => (
                  <div key={index} className={styles.bottomStatCard}>
                    <div className={styles.bottomStatIcon}>
                      <img
                        src={stat.icon}
                        alt={stat.title}
                        className={styles.bottomIconImage}
                      />
                    </div>
                    <p className={styles.bottomStatTitle}>{stat.title}</p>
                  </div>
                ))}
              </div>
              <p className={styles.bottomDescription}>
                It's time to move from sick care to real healthcare.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmployeeWellbeingComponent;
